import React, { useEffect, useState } from "react";

export default function ProgressRing({ percent = 0, size = 160, stroke = 12, label = "Overall" }) {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const [displayed, setDisplayed] = useState(0);

  useEffect(() => {
    const start = displayed;
    const target = Math.max(0, Math.min(100, percent || 0));
    const duration = 800;
    const startTs = performance.now();
    let raf;
    const tick = (ts) => {
      const t = Math.min(1, (ts - startTs) / duration);
      setDisplayed(Math.round(start + (target - start) * t));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [percent]);

  const offset = circumference - (displayed / 100) * circumference;

  return (
    <div className="relative inline-flex items-center justify-center" data-testid="progress-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          stroke="rgba(255,255,255,0.08)" strokeWidth={stroke} fill="none"
        />
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          stroke="#FF4343" strokeWidth={stroke} fill="none"
          strokeDasharray={circumference} strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 800ms ease-out" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-4xl font-black tracking-tight" data-testid="progress-ring-value">{displayed}%</span>
        <span className="text-[10px] tracking-[0.22em] uppercase text-white/50 mt-1">{label}</span>
      </div>
    </div>
  );
}
